import React, { useEffect, useState } from 'react';
const DISMISS_KEY = 'pwa-install-dismissed-until';
const DISMISS_DAYS = 14;
const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
const isIOSSafari = () => {
    const ua = navigator.userAgent;
    const iOSDevice = /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isSafari = /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
    return iOSDevice && isSafari;
};
const isDismissed = () => {
    const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
    return until > Date.now();
};
const InstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [visible, setVisible] = useState(false);
    const [showInstructions, setShowInstructions] = useState(false);
    useEffect(() => {
        if (isStandalone() || isDismissed())
            return;
        const onBeforeInstall = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setVisible(true);
        };
        const onInstalled = () => {
            setVisible(false);
            setDeferredPrompt(null);
        };
        window.addEventListener('beforeinstallprompt', onBeforeInstall);
        window.addEventListener('appinstalled', onInstalled);
        if (isIOSSafari()) {
            setVisible(true);
        }
        return () => {
            window.removeEventListener('beforeinstallprompt', onBeforeInstall);
            window.removeEventListener('appinstalled', onInstalled);
        };
    }, []);
    const handleInstall = async () => {
        if (deferredPrompt) {
            await deferredPrompt.prompt();
            const choice = await deferredPrompt.userChoice;
            setDeferredPrompt(null);
            if (choice.outcome === 'accepted') {
                setVisible(false);
            }
        }
        else {
            setShowInstructions(true);
        }
    };
    const handleDismiss = () => {
        const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
        localStorage.setItem(DISMISS_KEY, String(until));
        setVisible(false);
        setShowInstructions(false);
    };
    if (!visible)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "install-prompt", role: "dialog", "aria-label": "Install Swim Lab" },
            React.createElement("span", { className: "install-prompt-text" }, "Install Swim Lab for quick access"),
            React.createElement("button", { className: "install-prompt-btn", onClick: handleInstall }, "Install"),
            React.createElement("button", { className: "install-prompt-close", onClick: handleDismiss, "aria-label": "Dismiss install prompt" }, "\u00D7")),
        showInstructions && (React.createElement("div", { className: "install-prompt-modal", onClick: () => setShowInstructions(false) },
            React.createElement("div", { className: "install-prompt-modal-content", onClick: (e) => e.stopPropagation() },
                React.createElement("h3", null, "Add Swim Lab to Home Screen"),
                React.createElement("ol", null,
                    React.createElement("li", null,
                        "Tap the ",
                        React.createElement("strong", null, "Share"),
                        " button at the bottom of Safari"),
                    React.createElement("li", null,
                        "Scroll and tap ",
                        React.createElement("strong", null, "Add to Home Screen")),
                    React.createElement("li", null,
                        "Tap ",
                        React.createElement("strong", null, "Add"),
                        " to confirm")),
                React.createElement("button", { className: "install-prompt-btn install-prompt-btn-block", onClick: () => setShowInstructions(false) }, "Got it"))))));
};
export default InstallPrompt;
